import { __spreadArray } from "tslib";
import React, { useState } from "react";
import { ItemRow, SpinnerContainer, StyledTable, SubitemMarker, SubitemRow, TableHeader, } from "./styles";
import { IoIosArrowDown } from "react-icons/io";
import { AnimatePresence } from "framer-motion";
import { Spinner } from "../../Spinner/styles";
var NewAnimatePresence = AnimatePresence;
export var CollapseTable = function (_a) {
    var header = _a.header, tableStyles = _a.tableStyles, thStyles = _a.thStyles, tdStyles = _a.tdStyles, data = _a.data, alwaysLeft = _a.alwaysLeft, isLoading = _a.isLoading, firstColumnSize = _a.firstColumnSize;
    var _b = useState([]), isOpen = _b[0], setIsOpen = _b[1];
    var handleCollapse = function (index) {
        if (isOpen.includes(index)) {
            setIsOpen(function (state) { return state.filter(function (item) { return item !== index; }); });
        }
        else {
            setIsOpen(function (state) { return __spreadArray(__spreadArray([], state, true), [index], false); });
        }
    };
    var getAlignment = function (idx) {
        if (alwaysLeft) {
            return "flex-start";
        }
        if (idx === 0) {
            return "flex-start";
        }
        else if (idx === header.length - 1) {
            return "flex-end";
        }
        else {
            return "center";
        }
    };
    return (React.createElement(StyledTable, { style: tableStyles },
        React.createElement(TableHeader, { style: thStyles }, header.map(function (item, idx) {
            return (React.createElement("span", { key: idx, style: {
                    justifyContent: getAlignment(idx),
                    minWidth: idx === 0 && firstColumnSize ? firstColumnSize : undefined
                } }, item));
        })),
        isLoading ? (React.createElement(SpinnerContainer, null,
            React.createElement(Spinner, { background: "black", inverted: true, size: 25, spinnerWidth: 3 }))) : (React.createElement("div", null, data.map(function (item, idx2) {
            var hasSubitems = !!item.subitems;
            var keyArray = Object.keys(item).filter(function (key) { return key !== "subitems"; });
            var checkCollapse = isOpen.includes(idx2);
            return (React.createElement("div", { key: idx2, style: {
                    borderBottom: idx2 === data.length - 1 ? "none" : "1px solid #f4f4f4"
                } },
                React.createElement(ItemRow, { style: tdStyles, key: idx2, hasSubitems: hasSubitems, isOpen: checkCollapse, onClick: function () { return handleCollapse(idx2); } }, keyArray.map(function (key, idx3) {
                    return (React.createElement("span", { key: idx3, style: {
                            justifyContent: getAlignment(idx3),
                            minWidth: idx3 === 0 && firstColumnSize
                                ? firstColumnSize
                                : undefined
                        } },
                        idx3 === 0 && (React.createElement(IoIosArrowDown, { color: "#666666", size: 20, style: {
                                transform: checkCollapse
                                    ? "rotateX(180deg)"
                                    : "rotateX(0deg)",
                                transition: "all 0.2s"
                            } })),
                        item[key]));
                })),
                React.createElement(NewAnimatePresence, null, hasSubitems &&
                    checkCollapse &&
                    item.subitems.map(function (subitem, idx4) {
                        var subKeyArray = Object.keys(subitem);
                        return (React.createElement(SubitemRow, { key: idx4, layout: true, initial: {
                                height: 0,
                                opacity: 0,
                                padding: "0px 20px"
                            }, animate: {
                                height: 35,
                                opacity: 1,
                                padding: "7px 20px"
                            }, exit: { height: 0, opacity: 0, padding: "0px 20px" }, transition: {
                                opacity: { duration: 0.2 },
                                height: { duration: 0.3 },
                                padding: { duration: 0.3 }
                            } }, subKeyArray.map(function (key, idx5) {
                            return (React.createElement("span", { key: idx5, style: {
                                    justifyContent: getAlignment(idx5),
                                    minWidth: idx5 === 0 && firstColumnSize
                                        ? firstColumnSize
                                        : undefined
                                } },
                                idx5 === 0 && React.createElement(SubitemMarker, null),
                                subitem[key]));
                        })));
                    }))));
        })))));
};
//# sourceMappingURL=index.js.map